<template>
<div>
<v-container>
<v-row>
<v-col cols="12" sm="12" lg="12">
   <RegistroVentaAdmin></RegistroVentaAdmin>
</v-col>
</v-row>
</v-container>
</div>
</template>

<script>
import RegistroVentaAdmin from '@/components/tienda/venta/RegistroVentaAdmin.vue';

export default {
  data() {
    return {}
  },
  components: {
    RegistroVentaAdmin
  },
  methods: {}
}
</script>
